import { RootState } from '../../reducers'

export function documentTemplatesSuggestionsSelector(state: RootState) {
  return state.domain.documentTemplates.suggestions
}
